import { render, staticRenderFns } from "./GreyLyonLogo.vue?vue&type=template&id=3d95a2c3&scoped=true&"
var script = {}
import style0 from "./GreyLyonLogo.vue?vue&type=style&index=0&id=3d95a2c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d95a2c3",
  null
  
)

export default component.exports